import {request} from "@/api/request";


/**
 * 用户登录
 * @return {Promise<any>}
 * @constructor
 */

export function loginPage(name,password) {
    return request({
        url: '/public-dologin',
        data: {
            account:name,
            password:password,
        },
    });
}
/**
 * 注册
 */

export function signUp(name,telphone,xueli,idnumber) {
    return request({
        url: '/public-do_regists',
        data: {
            name:name,
            telphone:telphone,
            xueli:xueli,
            idnumber:idnumber,
        },
    });
}
// 获取用户信息
export function getUserInfo() {
    return request({
        url: '/index-get_member',
        data: {
        },
    });
}

// 退出登录
export function outLoginApi() {
    return request({
        url: '/public-loginout',
        data: {
        },
    });
}
// 获取用户
 /**
 * 志愿者报名
  * /index-get_user 获取用户
  参数：
  sp_flag 完成课程1 未完成为0
  cost_flag 缴费标识 （1为已缴费的账号，0为未缴费的账号）
  zyz_flag  志愿者标识   （1为已审核的报名志愿者，-1为待审核的报名志愿者，0为非志愿者）
  查询一般学员时，zyz_flag传入0.
  */
// eslint-disable-next-line no-unused-vars
export function getUser(cost_flag,zyz_flag=0,page) {
    return request({
        url: '/index-get_user',
        data: {
            cost_flag,
            zyz_flag:0,
            page,
        },
    });
}
/**
 * 学员学完课程报名志愿者
 * @return {Promise<any>}
 * @constructor
 */
export function volteerStudents(id) {
    return request({
        url: '/index-xueyuan_baogao_zhiyuanzhe',
        data: {
            id,
        },
    });
}
/**
 * 交钱开通权限
 * @return {Promise<any>}
 * @constructor
 */
export function toOpen(id) {
    return request({
        url: '/index-shenhe_quanxian',
        data: {
            id,
        },
    });
}
/**
 * 初批志愿者报名
 * @return {Promise<any>}
 * @constructor
 */

export function volteerOnce(name, telphone, minzu, sex, xuexiaozhuanye, zhengzhi, birthday = '未填', gangwei = '未填', zhicheng = '未填') {
    return request({
        url: '/public-zhiyuanzhe_regists',
        data: {
            name,
            telphone,
            minzu,
            sex,
            xuexiaozhuanye,
            birthday,
            zhengzhi,
            gangwei,
            zhicheng,
        },
    });
}
/**
 * 志愿者审核通过
 * @return {Promise<any>}
 * @constructor
 */

export function volteerPass(id) {
    return request({
        url: '/index-shenhe_quanxian_zhiyuanzhe',
        data: {
            id,
        },
    });
}
/**
 * 获得章节学习情况
 * @return {Promise<any>}
 * @constructor
 */

export function getStudy() {
    return request({
        url: '/index-get_studyed',
        data: {
        },
    });
}
/**
 * 修改信息
 * @return {Promise<any>}
 * @constructor
 */

export function reSetInfo(address,xueli) {
    return request({
        url: '/index-edit_user_msg',
        data: {
            address,
            xueli,
        },
    });
}
